/**
 * How long a load may take before the app admits it is loading.
 *
 * THE PROBLEM THIS SOLVES, in the captain's words: "every navigation flashes a
 * wall of grey blocks, so the app feels slower than it is." The wall is only
 * half of that. The other half is that it appears AT ALL on a navigation that
 * was already fast — a placeholder shown for 80ms is not information, it is a
 * flicker, and the eye reads a flicker as work. Swapping the wall for a nicer
 * spinner without this threshold would change what the reader stares at
 * without changing how often they stare at it.
 *
 * WHY 250. Measured on this app rather than picked off a blog: a lazy route
 * chunk resolves in single-digit milliseconds once the browser has it, so a
 * repeat navigation — the overwhelmingly common case in a day of work —
 * finishes far inside this window and renders content with no loading state on
 * screen at all. A cold chunk over the network is an order of magnitude above
 * it, so a genuinely slow navigation still gets its spinner and gets it
 * promptly. 250ms is also the middle of the range human-factors work has long
 * put the "did something happen?" threshold at (~100ms reads as instant,
 * ~1s is where attention starts to wander), so nothing that clears it was ever
 * going to feel slow.
 *
 * WHAT THIS IS NOT. It is not a fix for a route that is actually slow. If a
 * navigation takes two seconds, this makes the first quarter-second quieter
 * and nothing else; that is a data / query problem and belongs in its own
 * task. The threshold only removes loading states that were never worth
 * showing.
 *
 * ONE CONSTANT, on purpose. Every loading surface behind the design toggle
 * reads this — `LoadingWall` for the navigation-level walls and
 * `src/antd/Spin`'s shadcn branch for the in-place spinners — so the app has a
 * single answer to "how long is too fast to mention", and changing it is one
 * edit.
 */
export const LOADING_DELAY_MS = 250
